import {Box, Grid, TextField, useTheme} from "@mui/material";
import {styles} from "../../login/LoginStyles";
import FormSection from "../../../forms/FormSection";
import {observer} from "mobx-react";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import * as React from "react";
import Typography from "@mui/material/Typography";
import MoneyRenderer from "../../../utils/MoneyRenderer";

const JUDICIAL_STAGE_LABELS = {
    prejudicial_management: "Pre Gestión Judicial",
    judicial_management: "Gestión Judicial",
};

function JudicialManagementRequestComponent({customer, requestedStage, reason, overdueInvoicesCount, overdueInvoicesTotalPendingBalance}) {
    const theme = useTheme();
    const style = styles(theme);
    return (
        <LayoutContentWrapper
            renderContent={() => (
                <div>
                    <Box mb={2}>
                        <div style={style.titleContainer}>
                            <Typography
                                component="a"
                                href={`/current-accounts/${encodeURIComponent(customer.businessName)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant={"h2"}
                                sx={{color: theme.palette.primary.main, fontSize: '1.5em'}}
                            >
                                {customer.businessName}
                            </Typography>
                        </div>
                    </Box>

                    <FormSection title="Pase a Gestión Judicial">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Etapa solicitada"
                                    value={JUDICIAL_STAGE_LABELS[requestedStage]}
                                    fullWidth
                                    InputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Facturas vencidas"
                                    value={overdueInvoicesCount}
                                    fullWidth
                                    InputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    label="Monto adeudado"
                                    value={MoneyRenderer(overdueInvoicesTotalPendingBalance)}
                                    fullWidth
                                    InputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Motivo"
                                    value={reason}
                                    fullWidth
                                    multiline
                                    InputProps={{readOnly: true}}
                                />
                            </Grid>
                        </Grid>
                    </FormSection>
                </div>
            )}
        />
    );
}

export default observer(JudicialManagementRequestComponent);
